<div
  class="icon icon__wrapper"
  [ngClass]="'icon__wrapper--' + config().variant">
  <i
    class="icon__icon pi"
    [ngClass]="[config().icon, 'icon__icon--' + config().variant]"></i>
</div>
